import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../libs'
import { ClientBonusAccount } from './types'
import { $params } from '../../../features/router'
export const clientBonusAccountEditMounted = createEvent()
export const setClientBonusAccountEdit = createEvent<ClientBonusAccount>()
export const $clientBonusAccountEdit = restore(setClientBonusAccountEdit, {
  accountId: '',
  clientId: '',
  serverId: 0,
  status: '',
  balance: 0,
  login: 0,
  profit: 0,
  accountOpenedAt: '',
  accountClosingAt: '',
})

export const getClientBonusAccount = fx<void, ClientBonusAccount>({
  method: 'GET',
  url: '/client/bonus111',
})

sample({
  clock: clientBonusAccountEditMounted,
  source: $params,
  fn: (params) => {
    return {
      url: `/client/${params?.clientID}/bonus111/${params?.clientID}`,
    }
  },
  target: getClientBonusAccount,
})

// update profile model

sample({
  clock: getClientBonusAccount.doneData,
  fn: (doneData) => doneData.body,
  target: setClientBonusAccountEdit,
})
